import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import RoadClosureLocationsTable from './RoadClosureLocationsTable';
import RoadClosureLocationsEdit from './RoadClosureLocationsEdit';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { selectGeographicAreaPointsDd } from '@awp/stores/avalancheSlice';
import { FORM_MODE, Permissions } from '@awp/constants';
import Authorize from '@awp/components/Authorize';
import { useLocation } from 'react-router-dom';

const RoadClosureLocationsAdmin = (props) => {
  const location = useLocation();
  const { locationMode, locationData, locationArea } = location.state || {};
  const [mode, setMode] = useState(locationMode ? locationMode : FORM_MODE.LIST);
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
  const [area, setArea] = useState(locationArea ? locationArea : {});
  const [data, setData] = useState(locationData ? locationData : {});
  const areaPointsRaw = useSelector((state) => selectGeographicAreaPointsDd(state));
  const [areaPoints, setAreaPoints] = useState(areaPointsRaw);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    isMedium,
    isLarge,
    setMode,
    mode,
    area,
    setArea,
    setData,
    areaPoints,
  };

  const editProps = {
    setMode,
    mode,
    area,
    setArea,
    data,
    setData,
    areaPoints,
    setAreaPoints,
  };

  return (
    <AwpContainer>
      {mode === FORM_MODE.LIST ? (
        <Authorize requires={[Permissions.ReadAdminTools]}>
          <RoadClosureLocationsTable {...tableProps} />
        </Authorize>
      ) : (
        <Authorize requires={[Permissions.WriteAdminTools, Permissions.ReadAdminTools]}>
          <RoadClosureLocationsEdit {...editProps} />
        </Authorize>
      )}
    </AwpContainer>
  );
};

export default RoadClosureLocationsAdmin;
